import * as THREE from 'three';


  // Cargar nubes con gradiente de atardecer
  export function cargarNubes(object, scene) {
    
    const loader = new THREE.TextureLoader();
    const nubeURLs = [
      'https://cozumel-reef-maps.com.mx/Views/Default/img/nube_1.png',
      'https://cozumel-reef-maps.com.mx/Views/Default/img/nube_2.png',
      'https://cozumel-reef-maps.com.mx/Views/Default/img/nube_3.png'
    ];
    const textures = [];
    let cargadas = 0;
    nubeURLs.forEach((url, index) => {
      loader.load(url, (texture) => {
        textures[index] = texture;
        cargadas++;
        if (cargadas === nubeURLs.length) {
          crearNubes(object, textures, scene);
        }
      });
    });
  }


  // Crear sprites de nubes
export function crearNubes(object_, textures_, scene) {

  let terrainBox = null;

  object_.traverse((child) => {
    if (child.isMesh && /terrain/i.test(child.name)) {
      child.geometry.computeBoundingBox();
      terrainBox = child.geometry.boundingBox.clone();
      child.updateMatrixWorld(true);
      terrainBox.applyMatrix4(child.matrixWorld);
    }
  });

  if (!terrainBox) {
    console.warn("No se encontró TERRAIN en el objeto.");
    return;
  }

  const ancho  = terrainBox.max.x - terrainBox.min.x;
  const largo  = terrainBox.max.z - terrainBox.min.z;
  const altura = terrainBox.max.y;

  console.log("Dimensiones TERRAIN:", { ancho, largo, altura });

  // =========================================
  // CONFIGURACIÓN NUBES
  // =========================================
  const numNubes     = 8;
  const margen       = 0.1;

  // 🔽 MÁS ABAJO (antes: altura + largo * 0.5)
  const alturaNubes  = altura + (largo * 0.05);

  for (let i = 0; i < numNubes; i++) {

    const texture = textures_[Math.floor(Math.random() * textures_.length)];

    const spriteMat = new THREE.SpriteMaterial({
      map: texture,
      transparent: true,
      opacity: 0.45,
      depthWrite: false,
      alphaTest: 0.01
    });

    const sprite = new THREE.Sprite(spriteMat);

    const x = THREE.MathUtils.lerp(
      terrainBox.min.x - ancho * margen,
      terrainBox.max.x + ancho * margen,
      Math.random()
    );

    const z = THREE.MathUtils.lerp(
      terrainBox.min.z - largo * margen,
      terrainBox.max.z + largo * margen,
      Math.random()
    );

    // ligera variación vertical natural
    const y = alturaNubes + Math.random() * largo * 0.05;

    sprite.position.set(x, y, z);

    // 🔽 MÁS PEQUEÑAS (antes: largo * 0.6)
    if (texture.image) {
      const escalaBase = largo * 0.25;
      const variacion  = 0.7 + Math.random() * 0.6;

      const escalaX = escalaBase * variacion;
      const proporcion = texture.image.height / texture.image.width;
      const escalaY = escalaX * proporcion;

      sprite.scale.set(escalaX, escalaY, 1);
    }

    // evitar interacción
    sprite.raycast = () => {};

    scene.add(sprite);
  }
}

